import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatRippleModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { SmallstackCommonModule } from "@smallstack/common-components";
import { MaterialCssVarsModule } from "angular-material-css-vars";
import { AvatarImageComponent } from "./components/avatar-image/avatar-image.component";
import { IconComponent } from "./components/icon/icon.component";
import { InfoBoxComponent } from "./components/info-box/info-box.component";
import { MatActionButtonComponent } from "./components/mat-action-button/mat-action-button.component";
import { ThemeEditorComponent } from "./components/theme-editor/theme-editor.component";
import { ThemeTesterDialogComponent } from "./components/theme-tester-dialog/theme-tester-dialog.component";
import { TypeIconPipe } from "./pipes/type-icon.pipe";
import * as i0 from "@angular/core";
import * as i1 from "angular-material-css-vars";
export class SmallstackThemeModule {
}
SmallstackThemeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackThemeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmallstackThemeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.5", ngImport: i0, type: SmallstackThemeModule, declarations: [AvatarImageComponent,
        IconComponent,
        MatActionButtonComponent,
        ThemeEditorComponent,
        ThemeTesterDialogComponent,
        TypeIconPipe,
        InfoBoxComponent], imports: [CommonModule,
        MatTabsModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule, i1.MaterialCssVarsModule, MatButtonModule,
        MatDialogModule,
        MatRippleModule,
        MatTooltipModule,
        MatSelectModule,
        SmallstackCommonModule], exports: [AvatarImageComponent,
        IconComponent,
        MatActionButtonComponent,
        ThemeEditorComponent,
        ThemeTesterDialogComponent,
        TypeIconPipe,
        InfoBoxComponent] });
SmallstackThemeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackThemeModule, imports: [CommonModule,
        MatTabsModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule,
        MaterialCssVarsModule.forRoot(),
        MatButtonModule,
        MatDialogModule,
        MatRippleModule,
        MatTooltipModule,
        MatSelectModule,
        SmallstackCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackThemeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatTabsModule,
                        MatInputModule,
                        MatFormFieldModule,
                        FormsModule,
                        MaterialCssVarsModule.forRoot(),
                        MatButtonModule,
                        MatDialogModule,
                        MatRippleModule,
                        MatTooltipModule,
                        MatSelectModule,
                        SmallstackCommonModule
                    ],
                    declarations: [
                        AvatarImageComponent,
                        IconComponent,
                        MatActionButtonComponent,
                        ThemeEditorComponent,
                        ThemeTesterDialogComponent,
                        TypeIconPipe,
                        InfoBoxComponent
                    ],
                    exports: [
                        AvatarImageComponent,
                        IconComponent,
                        MatActionButtonComponent,
                        ThemeEditorComponent,
                        ThemeTesterDialogComponent,
                        TypeIconPipe,
                        InfoBoxComponent
                    ],
                    providers: []
                }]
        }] });
